import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Mail, Lock, LogIn, AlertCircle } from 'lucide-react';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        const result = await login(email, password);

        if (result.success) {
            navigate('/select-year');
        } else {
            setError(result.message);
        }
        
        setIsLoading(false);
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 relative overflow-hidden font-sans" dir="rtl">
            {/* Background Effects */}
            <div className="absolute top-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
            <div className="absolute bottom-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-orange-300/20 blur-[120px]" />

            <div className="w-full max-w-md relative z-10">
                <div className="bg-white/80 backdrop-blur-2xl border border-white rounded-lg overflow-hidden animate-in fade-in zoom-in duration-500">

                    
                    <div className="p-8 pb-6 text-center border-b border-slate-100">
                        <img src="/logo.png" alt="الشعار" className="w-20 h-20 object-contain mx-auto mb-3" />
                        
                        <h2 className="text-xl  tracking-tight text-slate-800 mb-1">
                            تسجيل الدخول
                        </h2>
                        <p className="text-slate-500 text-[13px]">
                            أدخل بياناتك للوصول إلى لوحة التحكم
                        </p>
                    </div>

                    <div className="p-8">
                        {error && (
                            <div className="mb-6 p-4 rounded-lg bg-red-50 border border-red-100 flex items-start space-x-3 space-x-reverse">
                                <AlertCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" />
                                <span className="text-red-600 text-sm">{error}</span>
                            </div>
                        )}


                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div className="space-y-2">
                                <label className="text-xs font-bold text-slate-600 tracking-wide block">
                                    البريد الإلكتروني
                                </label>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-primary transition-colors">
                                        <Mail className="w-5 h-5" />
                                    </div>
                                    <input
                                        type="email"
                                        required
                                        className="w-full bg-white border border-slate-200 text-slate-800 rounded-sm py-3 pr-11 pl-4 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all placeholder:text-slate-400"
                                        placeholder="admin@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />

                                </div>
                            </div>

                            <div className="space-y-2">
                                <div className="flex justify-between items-center">
                                    <label className="text-xs font-bold text-slate-600 tracking-wide">
                                        كلمة المرور
                                    </label>
                                    
                                </div>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none text-slate-400 group-focus-within:text-primary transition-colors">
                                        <Lock className="w-5 h-5" />
                                    </div>
                                    <input
                                        type="password"
                                        required
                                        className="w-full bg-white border border-slate-200 text-slate-800 rounded-sm py-3 pr-11 pl-4 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all placeholder:text-slate-400"
                                        placeholder="••••••••"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />

                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading}
                                className="w-full bg-primary hover:bg-primary-dark text-white font-bold rounded-lg py-3.5 px-4 transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center mt-4 group"
                            >

                                {isLoading ? (
                                    <span className="flex items-center space-x-2 space-x-reverse">
                                        <div className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                                        <span>يتم تسجيل الدخول...</span>
                                    </span>
                                ) : (
                                    <span className="flex items-center space-x-2 space-x-reverse group-hover:-translate-x-1 transition-transform">
                                        <span>تسجيل الدخول</span>
                                        <LogIn className="w-4 h-4" />
                                    </span>
                                )}
                            </button>
                        </form>
                    </div>
                </div>
                
                
            </div>
        </div>
    );
};

export default Login;
